export const API_STATUS_CONSTANT = {
  SUCCESS: 200,
};
